/**
 * RMA 主单状态，与后端 OrderStatusEnum 一致。
 * @see OrderStatusEnum
 */

/** 销售新建 RMA 后：待品质确认退货品状态与数量（待品质部接收） */
export const RMA_ORDER_STATUS_PENDING_QUALITY_RECEIVE = 10

/** 品质判定退回物料后：待工艺填写处理方案（待工艺部处理） */
export const RMA_ORDER_STATUS_PENDING_ENGINEERING = 20

/** 工艺提交方案后：待品质责任判定/结案（待品质责任判定） */
export const RMA_ORDER_STATUS_PENDING_QUALITY_FINALIZE = 25

/**
 * 四段子流程进行中（现场确认 / 客退品仓入库 / 补货 / 退货等新流程）。
 * 位于待品质责任判定（25）与已完结（30）之间。
 */
export const RMA_ORDER_STATUS_IN_PROGRESS = 27

/** 已完结 */
export const RMA_ORDER_STATUS_CLOSED = 30

/** 聚合导出，便于组件内整体挂到 data */
export const RMA_ORDER_STATUS = Object.freeze({
  /** 待品质部接收 */
  PENDING_QUALITY_RECEIVE: RMA_ORDER_STATUS_PENDING_QUALITY_RECEIVE,
  /** 待工艺部处理 */
  PENDING_ENGINEERING: RMA_ORDER_STATUS_PENDING_ENGINEERING,
  /** 待品质责任判定 */
  PENDING_QUALITY_FINALIZE: RMA_ORDER_STATUS_PENDING_QUALITY_FINALIZE,
  /** 处理中（子流程办理中） */
  IN_PROGRESS: RMA_ORDER_STATUS_IN_PROGRESS,
  /** 已完结 */
  CLOSED: RMA_ORDER_STATUS_CLOSED,
})

/** 详情顶栏 Tag 颜色（iView） */
export const RMA_ORDER_STATUS_TAG_COLOR = Object.freeze({
  [RMA_ORDER_STATUS.PENDING_QUALITY_RECEIVE]: 'blue',
  [RMA_ORDER_STATUS.PENDING_ENGINEERING]: 'cyan',
  [RMA_ORDER_STATUS.PENDING_QUALITY_FINALIZE]: 'warning',
  [RMA_ORDER_STATUS.IN_PROGRESS]: 'orange',
  [RMA_ORDER_STATUS.CLOSED]: 'success',
})

/** 无 statusText / 枚举未返回时的兜底文案 */
export const RMA_ORDER_STATUS_FALLBACK_TEXT = Object.freeze({
  [RMA_ORDER_STATUS.PENDING_QUALITY_RECEIVE]: '待品质部接收',
  [RMA_ORDER_STATUS.PENDING_ENGINEERING]: '待工艺部处理',
  [RMA_ORDER_STATUS.PENDING_QUALITY_FINALIZE]: '待品质责任判定',
  [RMA_ORDER_STATUS.IN_PROGRESS]: '处理中',
  [RMA_ORDER_STATUS.CLOSED]: '已完结',
})
